var map = {
	"./10_10.svg": 3921,
	"./1_10.svg": 7440,
	"./2_10.svg": 6926,
	"./3_10.svg": 321,
	"./4_10.svg": 2359,
	"./5_10.svg": 8926,
	"./6_10.svg": 300,
	"./7_10.svg": 7719,
	"./8_10.svg": 7445,
	"./9_10.svg": 9048,
	"./EY-logo-monochromatic.svg": 3166,
	"./EY-quiz-illustration.svg": 4029,
	"./arrow-right.svg": 6191,
	"./audit.svg": 3048,
	"./clap.svg": 6575,
	"./consulting.svg": 7740,
	"./gesture-hand.svg": 6298,
	"./intro.svg": 505,
	"./strategy.svg": 403,
	"./swipe-gesture.svg": 8860,
	"./taxes.svg": 4143,
	"./thumb-down.svg": 3857,
	"./thumb-up.svg": 7974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;